import { useStores } from '@/app/csr-src/models';
import { useTranslation } from '@/i18n/client';
import { Tab, Tabs } from '@mui/material';
import { observer } from 'mobx-react';
import OrderItems from '../orderItems';
import styles from './index.module.scss';

// 埋点
import { EXPOSURE_RECORD, sendClickTrack, type IExpoTrackParamsRecord } from '@/tracks/25335';

interface orderTabsProps {
  updateNumber: () => void;
}

const orderTabs: React.FC<orderTabsProps> = observer(({ updateNumber }) => {
  const { t } = useTranslation();
  const { orderStore } = useStores();

  const orderTabList = [
    {
      name: t('order.orderList.orderTabs.allTab'),
      state: '4096',
    },
    {
      name: t('order.orderList.orderTabs.unpaidTab'),
      state: '1',
    },
    {
      name: t('order.orderList.orderTabs.pendingReceiptTab'),
      state: '128',
    },
    {
      name: t('order.orderList.orderTabs.completedTab'),
      state: '1024',
    },
    {
      name: t('order.orderList.orderTabs.cancelledTab'),
      state: '-1',
    },
  ];
  let orderTabsDTOList = orderStore?.orderListInfo?.orderTabsDTOList || [];
  orderTabsDTOList = orderTabList.map((item: { name: string; state: string }) => {
    const matchedItem = orderTabsDTOList.find((ele: { state: string }) => ele.state === item.state);
    const itemCounts = matchedItem ? matchedItem.counts || 0 : 0;
    return {
      ...item,
      counts: itemCounts, // 如果没有找到，默认 num 为 0
    };
  });

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    // 加载中不可点击
    if (!orderStore.loading) {
      // 埋点
      const tabName = orderTabList.find((item) => item?.state === newValue)?.name;
      sendClickTrack.OrderList_OrderTypeTab({
        tab_name: tabName || t('order.orderList.orderTabs.allTab'),
      });
      orderStore.setOrderType(newValue);
      orderStore.setPageNum(1);
      orderStore.getOrderList({ page: '1', state: newValue });
      sessionStorage.removeItem('orderInfo');
    }
  };

  const tabLabelRender = (item: { name: string; counts?: number; state: string }) => {
    return (
      <div className={styles.label_wrap}>
        <div>{item.name}</div>
        {item.counts ? (
          <div className={styles.tab_label_num}>{item.counts > 99 ? '99+' : item.counts}</div>
        ) : null}
        {item.state === (orderStore.orderType || '4096') ? (
          <i className={styles.indicator_style} />
        ) : null}
      </div>
    );
  };

  // 曝光埋点参数
  const tabName = orderTabList.find((item) => item?.state === orderStore.orderType)?.name;
  const tabExpoParams: IExpoTrackParamsRecord['OrderList_OrderTypeTabExpo'] = {
    tab_name: tabName || t('order.orderList.orderTabs.allTab'),
  };

  return (
    <div
      className={styles.wrap}
      exptag={'exp|' + EXPOSURE_RECORD.OrderList_OrderTypeTabExpo}
      data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
      data-exptag-json-param={JSON.stringify(tabExpoParams)}
      id='orderList_page_container'
    >
      <Tabs
        value={orderStore.orderType || '4096'}
        onChange={handleChange}
        aria-label='order tabs'
        className={styles.order_tabs}
      >
        {orderTabsDTOList.map(
          (item: { name: string; state: string; counts: number }, index: number) => {
            return (
              <Tab
                label={tabLabelRender(item)}
                key={index}
                value={item.state}
                style={{ textTransform: 'none' }}
                disableRipple
              />
            );
          },
        )}
      </Tabs>
      <div className={styles.order_content}>
        <OrderItems updateNumber={updateNumber} />
      </div>
    </div>
  );
});

export default orderTabs;
